import {Component, OnDestroy, OnInit} from '@angular/core';
import {BroadcastsService} from "../services/broadcasts.service";
import {delay, take} from "rxjs/operators";
import {Broadcast} from "../model/broadcast/broadcast";
import BroadcastJson from '../../assets/broadcast-mock.json';
import {Control, ControlAction} from "../model/broadcast/control";
import {BehaviorSubject, Observable, Subscription, timer} from "rxjs";
import {IntroComponent} from "../broadcast-layer-module/broadcast-layer/intro/intro.component";
import {BroadcastLayerModule} from "../broadcast-layer-module/broadcast-layer.module";

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    standalone: true,
    imports: [
        BroadcastLayerModule
    ]
})
export class AboutComponent implements OnInit, OnDestroy {

  broadcastMock: Broadcast;
  status$: BehaviorSubject<ControlAction>;
  batter$: BehaviorSubject<ControlAction>;
  subs: Subscription[] = [];
  boxScore$: BehaviorSubject<ControlAction>;
  lineup$: BehaviorSubject<ControlAction>;
  previewControls: Control[];

  constructor(
    private broadcastService: BroadcastsService,
  ) {
    this.previewControls = [
      {component: "intro", action: "off"},
      {component: "status", action: "off"},
      {component: "lowerThird", action: "off"},
      {component: "batter", action: "off"},
      {component: "awayLineup", action: "off"},
      {component: "homeDefense", action: "off"},
      {component: "customTable", action: "off"},
      {component: "pitcher", action: "off"},
    ];
  }

  ngOnInit(): void {
    /*this.broadcastService.getMock().pipe(take(1)).subscribe(next => {
      this.broadcastMock = next;
    }).unsubscribe();*/
    const tmp = BroadcastJson;
    //this.broadcastMock = tmp as Broadcast;
    timer(0, 53 * 1000).subscribe(next => {
      this.previewAnimation();
    });
  }

  private previewAnimation(): void {
    timer(1 * 1000).subscribe(introOn => {
      this.previewControls.find(c => c.component === 'intro').action = 'on';
      timer(3 * 1000).subscribe(introOff => {
        this.previewControls.find(c => c.component === 'intro').action = 'off';
        timer(1 * 1000).subscribe(statusOn => {
          this.previewControls.find(c => c.component === 'status').action = 'on';
          timer(1 * 1000).subscribe(statusOn => {
            this.previewControls.find(c => c.component === 'lowerThird').action = 'on';
            timer(3 * 1000).subscribe(statusOn => {
              this.previewControls.find(c => c.component === 'lowerThird').action = 'off';
              timer(1 * 1000).subscribe(statusOn => {
                this.previewControls.find(c => c.component === 'awayLineup').action = 'on';
                timer(5 * 1000).subscribe(statusOn => {
                  this.previewControls.find(c => c.component === 'awayLineup').action = 'off';
                  timer(1 * 1000).subscribe(statusOn => {
                    this.previewControls.find(c => c.component === 'homeDefense').action = 'on';
                    timer(24 * 1000).subscribe(statusOn => {
                      this.previewControls.find(c => c.component === 'homeDefense').action = 'off';
                      timer(1 * 1000).subscribe(statusOn => {
                        this.previewControls.find(c => c.component === 'customTable').action = 'on';
                        timer(3 * 1000).subscribe(statusOn => {
                          this.previewControls.find(c => c.component === 'customTable').action = 'off';
                          timer(1 * 1000).subscribe(statusOn => {
                            this.previewControls.find(c => c.component === 'batter').action = 'on';
                            this.previewControls.find(c => c.component === 'pitcher').action = 'on';
                            timer(8 * 1000).subscribe(statusOn => {
                              this.previewControls.find(c => c.component === 'batter').action = 'off';
                              this.previewControls.find(c => c.component === 'pitcher').action = 'off';
                              this.previewControls.find(c => c.component === 'status').action = 'off';
                            });
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  animateComponent(control$: BehaviorSubject<ControlAction>): void {
    control$.next('off');
    let triggerSubs = timer(2 * 1000).subscribe(delay => {
      control$.next('on');
    });
    this.subs.push(triggerSubs);
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => {
      sub.unsubscribe();
    });
  }


  animateBatter() {
    this.animateComponent(this.batter$);
  }

  animateLineup() {
    this.animateComponent(this.lineup$);
  }
}
